import { FooterSummaryHeadingStyled } from '../FooterSummary/FooterSummary.styles'

export const EstimatedReturnHeadingStyled = FooterSummaryHeadingStyled
